import { createReducer, on } from '@ngrx/store';
import { setAppConfigData } from './app-config.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { SharedConfigWrapper } from '../../models/app-config/shared-config-wrapper';

export interface AppConfigState extends EntityState<SharedConfigWrapper> {}

export const appConfigAdapter: EntityAdapter<SharedConfigWrapper> =
  createEntityAdapter<SharedConfigWrapper>();
const initialState: AppConfigState = appConfigAdapter.getInitialState();

export const appConfigReducer = createReducer(
  initialState,
  on(setAppConfigData, (state, { payload }): AppConfigState => {
    return appConfigAdapter.addOne(payload, state);
  }),
);
